import React, { useContext } from "react";
import Select from "react-select";
import * as urlService from "../../view/urlService";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import { deepCopy, sortByAlphabet } from "../../utils";

function SelectMsbField({ msbList = [], setMsbId, msbId }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);
    // const location = history.location;

    //const [isComponentMounted, setIsComponentMounted] = useState(true);

    // useEffect(() => {
    //     return () => {
    //         setIsComponentMounted(false);
    //     };
    // }, []);

    const onChange = (selectedOption) => {
        const id = selectedOption?.value ?? -1;
        setMsbId(id);
        setConfig({ ...config, msbId: id });
        // if (isComponentMounted) {
        //     setConfig({ ...config, msbId: id });
        // }

        if (Number(id) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('msb')
            })
            return;
        }

        const msb = msbList.find(msb => msb.id === Number(id));

        if (msb) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('msb', msb.name)
            })
        }
    }

    const msbRenderList = deepCopy(msbList)
        .sort((a, b) => sortByAlphabet(a.name, b.name));

    const options = msbRenderList.map(msb => ({
        value: msb.id,
        label: msb.name
    }));


    return (
        <Select
            id="msb"
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(option => option.value === msbId) || null}
            onChange={onChange}
            options={options}
            isSearchable
            placeholder="Choose"
            noOptionsMessage={() => "No MSBs available"}
        />
    )

}

export default (SelectMsbField);
